(() => {
  const KEY = "bs_recent_searches_v1";
  const MAX = 8;

  const isDesktop = () => window.matchMedia("(min-width: 990px)").matches;

  const load = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  };

  const save = (arr) => localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));

  const uniqPushFront = (arr, term) => {
    const t = (term || "").trim();
    if (!t) return arr;
    return [t, ...arr.filter((x) => x !== t)].slice(0, MAX);
  };

  const escapeHtml = (s) =>
    String(s).replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));

  const initOne = (form) => {
    if (form.dataset.searchPillInited === "1") return;
    form.dataset.searchPillInited = "1";

    const input = form.querySelector(".header-search-pill__input");
    const ddStatic = form.querySelector(".search-pill-dd--static");
    const ddPredictive = form.querySelector(".search-pill-dd--predictive");
    const recentList = form.querySelector("[data-recent-list]");
    const clearBtn = form.querySelector("[data-recent-clear]");

    if (!input || !ddStatic || !recentList) return;

    const renderRecents = () => {
      const arr = load();
      if (!arr.length) {
        recentList.innerHTML = `<li class="search-pill-dd__empty">No recent searches.</li>`;
        return;
      }
      recentList.innerHTML = arr
        .map(
          (t) => `
          <li class="search-pill-dd__item">
            <a class="search-pill-dd__a" href="/search?q=${encodeURIComponent(t)}&options%5Bprefix%5D=last">${escapeHtml(t)}</a>
            <button type="button" class="search-pill-dd__x" data-recent-del="${escapeHtml(t)}" aria-label="remove">×</button>
          </li>`
        )
        .join("");
    };

    const setMode = (open) => {
      const hasQuery = (input.value || "").trim().length > 0;

      form.classList.toggle("is-open", !!open);
      form.classList.toggle("has-query", !!open && hasQuery);

      ddStatic.setAttribute("aria-hidden", !open || hasQuery ? "true" : "false");
      if (ddPredictive) ddPredictive.setAttribute("aria-hidden", !open || !hasQuery ? "true" : "false");
    };

    // 초기 렌더
    renderRecents();
    setMode(false);

    // submit 시 저장
    form.addEventListener("submit", () => {
      const next = uniqPushFront(load(), input.value || "");
      save(next);
      // 저장만 하고, 목록은 다음 열릴 때 갱신해도 되지만 UX 위해 즉시 갱신
      renderRecents();
    });

    // 개별 삭제
    recentList.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-recent-del]");
      if (!btn) return;
      e.preventDefault();
      const term = btn.getAttribute("data-recent-del");
      save(load().filter((x) => x !== term));
      renderRecents();
      input.focus();
    });

    // 전체 삭제
    clearBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      save([]);
      renderRecents();
      input.focus();
    });

    // 열기/전환
    input.addEventListener("focus", () => {
      renderRecents();     // 열릴 때 최신 목록 반영
      setMode(true);
    });

    input.addEventListener("input", () => setMode(true));

    // 바깥 클릭 닫기
    document.addEventListener("click", (e) => {
      if (!form.contains(e.target)) setMode(false);
    });
  };

  const boot = () => {
    if (!isDesktop()) return;
    document.querySelectorAll("form[data-search-pill]").forEach(initOne);
  };

  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("resize", boot);
})();
